export default __webpack_public_path__ + "static/media/pexels-andrea-piacquadio-3884085.d8070dbd.jpg";